import * as React from 'react';
import { useMutation } from '@apollo/client';

import ToastActions from 'actions/ToastActions';
import ConfirmDialog from 'components/ConfirmDialog';
import GET_CLASS_PROFILE_QUERY from 'groups/queries/ClassProfileQuery.gql';
import { useIntl } from 'lib/intl';
import REMOVE_GROUP_OWNER_MUTATION from './RemoveGroupOwnerMutation.gql';
import { RemoveGroupOwner, RemoveGroupOwnerVariables } from './__generated__/RemoveGroupOwner';

type Props = {
  groupName: string;
  groupUuid: string;
  onRequestHide?: () => void;
  ownerName: string;
  ownerUuid: string;
};

const RemoveGroupOwnerModal: React.FC<Props> = (props) => {
  const { groupName, groupUuid, onRequestHide, ownerName, ownerUuid } = props;
  const { formatMessage } = useIntl();
  const [removeGroupOwner] = useMutation<RemoveGroupOwner, RemoveGroupOwnerVariables>(
    REMOVE_GROUP_OWNER_MUTATION,
    {
      onCompleted: () =>
        ToastActions.showSuccessToast(
          formatMessage(
            { id: 'admin.classProfile.removeOwnerModal.successMessage' },
            { ownerName, groupName }
          )
        ),
      onError: (error) =>
        ToastActions.showErrorToast(
          error.message ||
            formatMessage(
              { id: 'admin.classProfile.removeMemberModal.errorMessage' },
              { groupName, ownerName }
            )
        ),
      refetchQueries: [{ query: GET_CLASS_PROFILE_QUERY, variables: { classUuid: groupUuid } }],
    }
  );

  return (
    <ConfirmDialog
      title={formatMessage({ id: 'admin.classProfile.removeOwnerModal.warningText' })}
      subtext={formatMessage(
        { id: 'admin.classProfile.removeOwnerModal.warningSubtext' },
        { ownerName, groupName }
      )}
      actionButtonText={formatMessage({ id: 'admin.classProfile.removeOwnerModal.confirmButton' })}
      actionButtonColor="apple"
      cancelButtonText={formatMessage({ id: 'admin.classProfile.removeOwnerModal.cancelButton' })}
      cancelButtonColor="mascot"
      cancelButtonLevel="text"
      onConfirm={() =>
        removeGroupOwner({
          variables: {
            input: {
              userUuid: ownerUuid,
              groupUuid,
            },
          },
        })
      }
      onRequestHide={onRequestHide}
    />
  );
};

export default RemoveGroupOwnerModal;
